/*eslint-disable import/no-anonymous-default-export*/
export default {
  CREATE_CAR: () => `/vendor/vendorCars/addMyCar`,
  GET_CAR: () => '/vendor/cars/getAll',
  GET_VENDOR_CAR: () => `/vendor/vendorCars/getMyCars`,
  GET_VENDOR_CAR_ID: (id) => `/vendor/vendorCars/getById/${id}`,
  UPDATE_CAR_BY_ID: (id) => `/vendor/vendorCars/update/${id}`,
  UPLOAD_IMAGE: () => '/admin/uploads',

};